export function findIndexAndParent(items, searcher) {
    for (let i = 0, l = items.length; i < l; ++i) {
        const element = items[i];

        const isTarget = searcher(element);

        if ( isTarget ) {
            return {
                parent: items,
                index: i,
                found: true,
                element
            };
        }

        if ( element.elements ) {
            const childResult = findIndexAndParent(element.elements, searcher);
            if ( childResult.found ) {
                return childResult;
            }
        }
    }

    return {
        parent: null,
        index: null,
        found: false,
        element: null
    };
}
